import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  grid-row: ", ";\n  grid-column: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  grid-row: ", ";\n  grid-column: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  grid-row: ", ";\n  grid-column: ", ";\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: ", ";\n  height: ", ";\n\n  margin: 2px 0;\n  overflow: hidden;\n\n  border: 1px solid\n    var(", ");\n  outline-offset: 2px;\n\n  transition: border-color ", " var(", ");\n\n  appearance: none;\n\n  /* Apperance: none causes the outline styles to be removed in Firefox.\n   * This aims to restore native focus outline\n   */\n  &:-moz-focusring {\n    outline-style: auto;\n  }\n\n  /* Checked */\n  &:checked {\n    border-color: var(\n      ", "\n    );\n  }\n\n  /* Read only */\n  &[readonly] {\n    background-color: var(\n      ", "\n    );\n    border-color: var(\n      ", "\n    );\n  }\n\n  /* Invalid */\n  &:invalid {\n    border-color: var(\n      ", "\n    );\n    /* Remove glow in FF */\n    box-shadow: none;\n  }\n\n  /* Disabled */\n  &:disabled {\n    background-color: transparent;\n    border-color: var(\n      ", "\n    );\n\n    cursor: not-allowed;\n    opacity: 1;\n  }\n\n  /* Enabled\n   * Input type radio/checkbox has no native :read-only support\n   */\n  &:enabled:not([readonly]) {\n    cursor: pointer;\n  }\n\n  /* Focus */\n  &:enabled:valid:not([readonly]):focus {\n    border-color: var(\n      ", "\n    );\n  }\n\n  /* Hover */\n  &:enabled:valid:not([readonly]):hover {\n    border-color: var(\n      ", "\n    );\n  }\n\n  /* Checked hover */\n  &:enabled:not([readonly]):valid:checked:hover {\n    border-color: var(\n      ", "\n    );\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    &::before {\n      transition: none;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-row-gap: ", ";\n  grid-column-gap: var(", ");\n  grid-template-rows:\n    [ ", " ] auto\n    [ ", " ] auto;\n  grid-template-columns:\n    [ ", " ] ", "\n    [ ", " ] 1fr;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { injectSpacing } from '../../../api/spacing/injectSpacing';
import { getEasing } from '../../../utils/getEasing';
export var inputSize = '20px';
export var fadeDuration = '0.25s';
export var StyledContainer = styled.div(_templateObject(), function (props) {
  return (props.hasHint || props.hasValidationMessage) && "var(".concat(props.theme.responsive.spacing.s, ")");
}, function (props) {
  return props.theme.responsive.spacing.s;
}, "interaction"
/* GridRows.interaction */
, "description"
/* GridRows.description */
, "input"
/* GridCols.input */
, inputSize, "label"
/* GridCols.label */
, injectSpacing('margin'));
export var StyledInput = styled.input(_templateObject2(), "interaction"
/* GridRows.interaction */
, "input"
/* GridCols.input */
, inputSize, inputSize, function (props) {
  return props.theme.colors.interaction.secondary.default;
}, fadeDuration, getEasing, function (props) {
  return props.theme.colors.interaction.secondary.filled;
}, function (props) {
  return props.theme.colors.interaction.tertiary.default;
}, function (props) {
  return props.theme.colors.interaction.tertiary.default;
}, function (props) {
  return props.invalid && props.theme.colors.ui.error;
}, function (props) {
  return props.theme.colors.interaction.secondary.disabled;
}, function (props) {
  return props.theme.colors.interaction.secondary.focus;
}, function (props) {
  return props.theme.colors.interaction.secondary.hover;
}, function (props) {
  return props.theme.colors.interaction.secondary.hover;
});
export var StyledLabelWrapper = styled.div(_templateObject3(), "interaction"
/* GridRows.interaction */
, "label"
/* GridCols.label */
);
export var StyledDescriptionContainer = styled.div(_templateObject4(), "description"
/* GridRows.description */
, "label"
/* GridCols.label */
);